module.exports = __webpack_public_path__ + "static/media/Conventional-pathology-three@2x.740ea5b9.png";